module.exports = {
    "admin.user.list": "Xem danh sách",
    "admin.user.create": "Thêm mới",
    "admin.user.detail": "Xem chi tiết",
    "admin.user.update": "Cập nhật thông tin",
    "admin.user.remove": "Xoá",

    "admin.permissions.list": "Xem danh sách quyền",
    "admin.permissions.update": "Phân quyền",
    "admin.permissions.get_by_role": "Lấy danh sách quyền theo vai trò",
    "admin.permissions.get_by_user": "Lấy danh sách quyền theo nhân viên",

    "admin.config.update": "Cấu hình email hệ thống",

    "admin.services.list": "Xem danh sách",
    "admin.services.create": "Thêm mới",
    "admin.services.update": "Cập nhật",
    "admin.services.remove": "Xóa",

    "admin.customer_class.list": "Xem danh sách",
    "admin.customer_class.create": "Thêm mới",
    "admin.customer_class.update": "Cập nhật",
    "admin.customer_class.remove": "Xóa",

    "admin.relationship_types.list": "Xem danh sách",
    "admin.relationship_types.create": "Thêm mới",
    "admin.relationship_types.update": "Cập nhật",
    "admin.relationship_types.remove": "Xóa",

    "admin.customer_status.list": "Xem danh sách",
    "admin.customer_status.create": "Thêm mới",
    "admin.customer_status.update": "Cập nhật",
    "admin.customer_status.remove": "Xóa",

    "admin.interaction_statuses.list": "Xem danh sách",
    "admin.interaction_statuses.create": "Thêm mới",
    "admin.interaction_statuses.update": "Cập nhật",
    "admin.interaction_statuses.remove": "Xóa",

    "admin.interaction_types.list": "Xem danh sách",
    "admin.interaction_types.create": "Thêm mới",
    "admin.interaction_types.update": "Cập nhật",
    "admin.interaction_types.remove": "Xóa",

    "admin.customer.list": "Xem danh sách",
    "admin.customer.orthodontic_customer": "Xem danh sách khách chỉnh nha",
    "admin.customer.create": "Thêm mới",
    "admin.customer.import_excel": "Import từ excel",
    "admin.customer.detail": "Xem chi tiết",
    "admin.customer.update": "Cập nhật",
    "admin.customer.remove": "Xóa",
    "admin.customer.phonenumber": "Xem số điện thoại",
    "admin.customer.voicecall": "Gọi điện thoại cho khách",
    "admin.customer.create_from_chat": "Tạo khách hàng từ form chat",
    "admin.customer.update_from_chat": "Cập nhật khách hàng từ form chat",
    "admin.customer.update_media": "Cập nhật ảnh tình trạng hiện tại",
    "admin.customer.transfer_to_staff": "Giao khách hàng cho telesale",
    "admin.customer.payment_history": "Xem lịch sử thanh toán",
    "admin.customer.input_pin_code": "Xem số điện thoại bằng mã PIN",
    "admin.customer.phonenumber_update": "Cập nhật số điện thoại",
    "admin.customer.update_image_profile": "Cập nhật ảnh hồ sơ",
    "admin.customer.remove_image_profile": "Xóa ảnh hồ sơ",
    "admin.customer.export": "Xuất file",
    "admin.customer.set_primary_phone": "Cập nhật số điện thoại chính",
    "admin.customer.view_finance": "Xem thông tin tài chính",


    "admin.customer_services.list": "Xem danh sách",
    "admin.customer_services.create": "Tạo mới",
    "admin.customer_services.update": "Cập nhật",
    "admin.customer_services.remove": "Xóa",
    "admin.customer_services.detail": "Xem chi tiết",
    "admin.customer_services.create_exam_visit": "Thêm lần khám",
    "admin.customer_services.update_exam_visit": "Cập nhật lần khám",
    "admin.customer_services.exam_visit_remove": "Xóa lần khám",
    "admin.customer_services.export": "Xuất file",
    "admin.customer_services.convert_to_service": "Chuyển đổi dịch vụ sang dịch vụ khác",

    "admin.customer_source.list": "Xem danh sách",
    "admin.customer_source.create": "Thêm mới",
    "admin.customer_source.update": "Cập nhật",
    "admin.customer_source.remove": "Xóa",

    "admin.page_manager.list": "Danh sách trang",
    "admin.page_manager.connect_facebook": "Thực hiện kết nối facebook",
    "admin.page_manager.update": "Cập nhật trang",
    "admin.page_manager.update_status": "Kích hoạt trang",

    "admin.branch.list": "Xem danh sách",
    "admin.branch.create": "Thêm mới",
    "admin.branch.detail": "Xem chi tiết",
    "admin.branch.update": "Cập nhật",
    "admin.branch.remove": "Xóa",
    "admin.branch.remove_image": "Xóa ảnh cơ sở",

    "admin.role_group.list": "Xem danh sách",
    "admin.role_group.create": "Thêm mới",
    "admin.role_group.update": "Cập nhật",
    "admin.role_group.remove": "Xóa",

    "admin.roles.list": "Xem danh sách",
    "admin.roles.create": "Thêm mới",
    "admin.roles.update": "Cập nhật",
    "admin.roles.remove": "Xóa",

    "admin.customer_schedule.list": "Xem danh sách",
    "admin.customer_schedule.create": "Thêm mới",
    "admin.customer_schedule.detail": "Xem chi tiết",
    "admin.customer_schedule.update": "Cập nhật",
    "admin.customer_schedule.remove": "Xóa",
    "admin.customer_schedule.update_status": "Cập nhật trạng thái lịch hẹn",
    "admin.customer_schedule.transfer_to_staff": "Giao lich hẹn cho tư vấn viên",
    "admin.customer_schedule.change_schedule": "Chuyển lịch hẹn",
    "admin.customer_schedule.after_service_care_update": "Cập nhật CSKH sau dịch vụ",
    "admin.customer_schedule.export": "Xuất file excel",
    "admin.customer_schedule.list2": "Xem danh sách lịch hẹn trong quản lý chỉnh nha",

    "admin.diseases.list": "Xem danh sách",
    "admin.diseases.create": "Thêm mới",
    "admin.diseases.update": "Cập nhật",
    "admin.diseases.remove": "Xóa",

    "admin.blood_groups.list": "Xem danh sách",
    "admin.blood_groups.create": "Thêm mới",
    "admin.blood_groups.update": "Cập nhật",
    "admin.blood_groups.remove": "Xóa",

    "admin.voucher.list": "Xem danh sách",
    "admin.voucher.create": "Thêm mới",
    "admin.voucher.detail": "Xem chi tiết",
    "admin.voucher.update": "Cập nhật",
    "admin.voucher.remove": "Xóa",
    "admin.voucher.apply_customer": "Thêm voucher cho khách",
    "admin.voucher.customer_update": "Cập nhật voucher của khách",
    "admin.voucher.voucher_remove": "Xóa voucher của khách",

    "admin.order.list": "Xem danh sách",
    "admin.order.create": "Thêm mới",
    "admin.order.detail": "Xem chi tiết",
    "admin.order.update": "Cập nhật",
    "admin.order.remove": "Xóa",

    "admin.product_warehouse.list": "Xem danh sách",
    "admin.product_warehouse.create": "Thêm mới",
    "admin.product_warehouse.update": "Cập nhật",
    "admin.product_warehouse.remove": "Xóa",

    "admin.product_group.list": "Xem danh sách",
    "admin.product_group.create": "Thêm mới",
    "admin.product_group.update": "Cập nhật",
    "admin.product_group.remove": "Xóa",

    "admin.product.list": "Xem danh sách",
    "admin.product.detail": "Xem chi tiết",
    "admin.product.update": "Cập nhật",
    "admin.product.remove": "Xóa",
    "admin.product.statistics": "Xem thống kê tồn kho",
    "admin.product.stats_export": "Xuất file excel thống kê",

    "admin.product_receipt_import.list": "Xem danh sách",
    "admin.product_receipt_import.create": "Thêm mới",
    "admin.product_receipt_import.detail": "Xem chi tiết",
    'admin.product_receipt_import.update': "Cập nhật",
    "admin.product_receipt_import.export": "Xuất file excel",
    'admin.product_receipt_import.remove': "Xóa",

    "admin.product_receipt_export.list": "Xem danh sách",
    "admin.product_receipt_export.create": "Thêm mới",
    "admin.product_receipt_export.update": "Cập nhật",
    "admin.product_receipt_export.detail": "Xem chi tiết",
    "admin.product_receipt_export.export": "Xuất file excel",
    "admin.product_receipt_export.remove": "Xóa",

    'admin.product_supplier.list': "Xem danh sách",
    'admin.product_supplier.create': "Thêm mới",
    'admin.product_supplier.update': "Cập nhật",
    'admin.product_supplier.remove': "Xóa",

    'admin.unit.list': "Xem danh sách",
    'admin.unit.create': "Thêm mới",
    'admin.unit.update': "Cập nhật",
    'admin.unit.remove': "Xóa",

    'admin.product_status.list': "Xem danh sách",
    'admin.product_status.create': "Thêm mới",
    'admin.product_status.update': "Cập nhật",
    'admin.product_status.remove': "Xóa",

    "admin.guide.list": "Xem danh sách",
    "admin.guide.create": "Thêm mới",
    "admin.guide.detail": "Xem chi tiết",
    "admin.guide.update": "Cập nhật",
    "admin.guide.remove": "Xóa",

    "admin.work_report.list": "Xem danh sách",
    "admin.work_report.create": "Tạo mới",
    "admin.work_report.update": "Cập nhật",
    "admin.work_report.detail": "Xem chi tiết",
    "admin.work_report.remove": "Xóa",
    "admin.work_report.export": "Xuất file excel",

    "admin.telegram.list": "Xem danh sách",
    "admin.telegram.create": "Tạo mới",
    "admin.telegram.detail": "Chi tiết",
    "admin.telegram.update": "Cập nhật",
    "admin.telegram.remove": "Xóa",

    "admin.lookup_customer.list": "Xem danh sách",
    "admin.lookup_customer.transfer_to_staff": "Giao khách hàng cho telesale",

    "admin.customer_telesale.list": "Xem danh sách",
    "admin.customer_telesale.detail": "Xem chi tiết",
    "admin.customer_telesale.update": "Cập nhật",
    "admin.customer_telesale.update_result": "Cập nhật kết quả tư vấn",
    "admin.customer_telesale.remove": "Xóa",
    "admin.customer_telesale.telesale_again": "Giao cho nhân viên telesale lại",

    "admin.customer_consultant_direct.list": "Xem danh sách",
    "admin.customer_consultant_direct.detail": "Xem chi tiết",
    "admin.customer_consultant_direct.update": "Cập nhật",
    "admin.customer_consultant_direct.update_result": "Cập nhật kết quả tư vấn",
    "admin.customer_consultant_direct.remove": "Xóa",

    "admin.customer_potential.list": "Xem danh sách",
    "admin.customer_potential.create": "Thêm mới",
    "admin.customer_potential.import_excel": "Import excel",
    "admin.customer_potential.phonenumber": "Xem số điện thoại",
    "admin.customer_potential.voicecall": "Gọi điện thoại cho khách",
    "admin.customer_potential.update": "Cập nhật",
    "admin.customer_potential.remove": "Xóa",
    "admin.customer_potential.input_pin_code": "Xem số điện thoại bằng mã PIN",

    "admin.cash_receipt.list": "Xem danh sách",
    "admin.cash_receipt.create": "Tạo phiếu",
    "admin.cash_receipt.detail": "Xem chi tiết",
    "admin.cash_receipt.update": "Cập nhật",
    "admin.cash_receipt.remove": "Xóa",
    "admin.cash_receipt.update_status": "Cập nhật trạng thái phiếu",
    "admin.cash_receipt.import_excel": "Import từ excel",

    "admin.cash_book.list": "Xem danh sách",

    "admin.payment_voucher.list": "Xem danh sách",
    "admin.payment_voucher.create": "Tạo phiếu",
    "admin.payment_voucher.detail": "Xem chi tiết",
    "admin.payment_voucher.update": "Cập nhật",
    "admin.payment_voucher.remove": "Xóa",
    "admin.payment_voucher.update_status": "Cập nhật trạng thái phiếu",

    "admin.reward_spin.list": "Xem giải thưởng",
    "admin.reward_spin.remove": "Xóa",
    "admin.reward_spin.create": "Quay",
    "admin.reward_spin.config": "Cấu hình",
    "admin.reward_spin.update": "Cập nhật",
    "admin.reward_spin.customer_has_list": "Xem khách hàng đã quay",
    "admin.reward_spin.remove_customer_has": "Xóa khách hàng đã quay",

    "admin.view_phonenumber.list": "Xem danh sách",
    "admin.view_phonenumber.phonenumber": "Xem số điện thoại",
    "admin.view_phonenumber.remove": "Xóa",

    "admin.project.list": "Xem danh sách",
    "admin.project.create": "Tạo mới",
    "admin.project.update": "Cập nhật",
    "admin.project.clone": "Nhân bản",
    "admin.project.remove": "Xóa",

    "admin.project_based_job.list": "Xem danh sách",
    "admin.project_based_job.create": "Tạo mới",
    "admin.project_based_job.update": "Cập nhật",
    "admin.project_based_job.detail": "Xem chi tiết",
    "admin.project_based_job.update_result": "Cập nhật kết quả",
    "admin.project_based_job.update_status": "Cập nhật tình trạng",
    "admin.project_based_job.assign": "Giao việc cho nhân viên",
    "admin.project_based_job.remove": "Xóa",

    "admin.messenger.thread": "Danh sách cuộc trò chuyện",
    "admin.messenger.message": "Xem chi tiết tin nhắn",
    "admin.messenger.send_message": "Gửi tin nhắn",
    "admin.messenger.update_customer": "Cập nhật khách hàng",
    "admin.messenger.customer_info": "Xem thông tin khách hàng",
    "admin.messenger.delete_comment": "Xóa bình luận",
    "admin.messenger.hide_comment": "Ẩn/Hiện bình luận",

    "admin.customer_medical.create": "Cập nhật",

    "admin.card_issued_count.list": "Xem danh sách",
    "admin.card_issued_count.create": "Tạo mới",
    "admin.card_issued_count.update": "Cập nhật",
    "admin.card_issued_count.detail": "Xem chi tiết",
    "admin.card_issued_count.remove": "Xóa",

    "admin.card_release_tracking.list": "Xem danh sách",
    "admin.card_release_tracking.create": "Tạo mới",
    "admin.card_release_tracking.update": "Cập nhật",
    "admin.card_release_tracking.detail": "Xem chi tiết",
    "admin.card_release_tracking.remove": "Xóa",

    "admin.card_type.list": "Xem danh sách",
    "admin.card_type.create": "Tạo mới",
    "admin.card_type.update": "Cập nhật",
    "admin.card_type.remove": "Xóa",

    "admin.card_pending_customers.list": "Xem danh sách",
    "admin.card_pending_customers.assign_to_staff": "Giao cho nhân viên",
    "admin.card_pending_customers.export": "Xuất excel",

    "admin.customer_data.lookup": "Tra cứu khách hàng",
    "admin.customer_data.create": "Thêm mới",
    "admin.customer_data.update": "Cập nhật",

    "admin.media_categories.list": "Xem danh sách",
    "admin.media_categories.create": "Thêm mới",
    "admin.media_categories.update": "Cập nhật",
    "admin.media_categories.remove": "Xóa",

    "admin.media.list": "Xem danh sách",
    "admin.media.create": "Thêm mới",
    "admin.media.remove": "Xóa",
    "admin.media.update": "Cập nhật",

    "admin.document_categories.list": "Xem danh sách",
    "admin.document_categories.create": "Thêm mới",
    "admin.document_categories.update": "Cập nhật",
    "admin.document_categories.remove": "Xóa",

    "admin.documents.list": "Xem danh sách",
    "admin.documents.create": "Thêm mới",
    "admin.documents.update": "Cập nhật",
    "admin.documents.remove": "Xóa",

    "admin.customer_group.list": "Xem danh sách",
    "admin.customer_group.create": "Thêm mới",
    "admin.customer_group.update": "Cập nhật",
    "admin.customer_group.remove": "Xóa",


    "admin.customer_payment.add": "Thêm mới",
    "admin.customer_payment.update": "Cập nhật",
    "admin.customer_payment.remove": "Xóa",

    "admin.additional_cost.add": "Thêm mới",
    "admin.additional_cost.update": "Cập nhật",
    "admin.additional_cost.remove": "Xóa",

    "admin.commission.list": "Xem danh sách",
    "admin.commission.remove": "Xóa",

    "admin.commission_rule.list": "Xem danh sách",
    "admin.commission_rule.create": "Tạo mới",
    "admin.commission_rule.update": "Cập nhật",
    "admin.commission_rule.assignment": "Cập nhât nhân viên, dịch vụ",
    "admin.commission_rule.remove": "Xóa",

    "admin.commission_revenue.list": "Xem danh sách",
    "admin.commission_revenue.create": "Tạo mới",
    "admin.commission_revenue.update": "Cập nhật",
    "admin.commission_revenue.assignment": "Cập nhật nhân viên, dịch vụ",
    "admin.commission_revenue.remove": "Xóa",

    "admin.zalo.grant_permission": "Kết nối Zalo OA",
    "admin.zalo.list": "Xem danh sách Zalo OA",

    "admin.audit_logs.search": "Xem danh sách",
    "admin.audit_logs.rollback": "Rollback",
    "admin.audit_logs.detail": "Chi tiết",

    "admin.labos.list": "Xem danh sách",
    "admin.labos.create": "Tạo mới",
    "admin.labos.detail": "Xem chi tiết",
    "admin.labos.update": "Cập nhật",
    "admin.labos.remove": "Xóa",

    "admin.labo_cases.list": "Xem danh sách",
    "admin.labo_cases.create": "Tạo mới",
    "admin.labo_cases.detail": "Xem chi tiết",
    "admin.labo_cases.update": "Cập nhật",
    "admin.labo_cases.remove": "Xóa",
    "admin.labo_cases.status_statistics": "Xem thống kê theo trạng thái",
    "admin.labo_cases.customer_statistics": "Xem thống kê theo khách hàng",

    "admin.statistics.revenue": "Doanh thu & doanh số",
    "admin.statistics.staff_revenue_yearly": "Doanh số nhân viên (năm)",
    "admin.statistics.staff_revenue_detail": "Doanh số nhân viên chi tiết",
    "admin.statistics.staff_revenue_yearly_export": "Xuất excel doanh số nhân viên (năm)",
    "admin.statistics.staff_revenue_detail_export": "Xuất excel doanh số nhân viên chi tiết",
    "admin.statistics.assistants_support_cases": "Thống kê ca hỗ trợ của phụ tá",
    "admin.statistics.assistants_support_case_export": "Xuất excel ca hỗ trợ của phụ tá",
    "admin.statistics.assistants_support_case_export_all": "Export tổng hợp số ca phụ toàn bộ phụ tá",
    "admin.statistics.customer_visits": "Thống kê lượt khách đến theo nhóm dịch vụ",

    "admin.branch_fund.list": "Xem danh sách",
    "admin.branch_fund.create": "Thêm mới",
    "admin.branch_fund.update": "Cập nhật",
    "admin.branch_fund.detail": "Xem chi tiết",
    "admin.branch_fund.remove": "Xóa",

    "admin.partner_appointments.list": "Xem danh sách",
    "admin.partner_appointments.detail": "Xem chi tiết",

    "admin.partner_telesales.list": "Xem danh sách",

    "admin.partner_customers.list": "Xem danh sách",
    "admin.partner_customers.detail": "Xem chi tiết",

    "admin.procedures.list": "Xem danh sách",
    "admin.procedures.create": "Tạo mới",
    "admin.procedures.detail": "Xem chi tiết",
    "admin.procedures.update": "Cập nhật",
    "admin.procedures.remove": "Xóa",

    "admin.customer_care_categories.list": "Xem danh sách",
    "admin.customer_care_categories.create": "Tạo mới",
    "admin.customer_care_categories.detail": "Xem chi tiết",
    "admin.customer_care_categories.update": "Cập nhật",
    "admin.customer_care_categories.remove": "Xóa",

    "admin.customer_care_logs.list": "Xem danh sách",
    "admin.customer_care_logs.create": "Thêm mới",
    "admin.customer_care_logs.detail": "Xem chi tiết",
    "admin.customer_care_logs.update": "Cập nhật",
    "admin.customer_care_logs.remove": "Xóa",

    "admin.customer_complaints.list": "Xem danh sách",
    "admin.customer_complaints.create": "Thêm mới",
    "admin.customer_complaints.detail": "Xem chi tiết",
    "admin.customer_complaints.update": "Cập nhật",
    "admin.customer_complaints.remove": "Xóa",

    "admin.instruction_templates.list": "Xem danh sách",
    "admin.instruction_templates.create": "Tạo mới",
    "admin.instruction_templates.detail": "Xem chi tiết",
    "admin.instruction_templates.update": "Cập nhật",
    "admin.instruction_templates.remove": "Xóa",

    "admin.prescription_templates.list": "Xem danh sách",
    "admin.prescription_templates.create": "Tạo mới",
    "admin.prescription_templates.detail": "Xem chi tiết",
    "admin.prescription_templates.update": "Cập nhật",
    "admin.prescription_templates.remove": "Xóa",

    "admin.images.create_folder": "Tạo thư mục ảnh",
    "admin.images.update_folder": "Cập nhật thư mục ảnh",
    "admin.images.create_image": "Tải lên ảnh",
    "admin.images.delete_image": "Xóa ảnh",

    "admin.milestones.list": "Xem danh sách",
    "admin.milestones.update": "Cập nhật",
    "admin.milestones.notify": "Gửi thống báo",

    // Bình luận chỉnh nha
    "admin.orthodontic_comments.create": "Tạo bình luận chỉnh nha",
    "admin.orthodontic_comments.update": "Cập nhật bình luận chỉnh nha",
    "admin.orthodontic_comments.delete": "Xóa bình luận chỉnh nha",

    // Bệnh án chỉnh nha
    "admin.orthodontic_plans.update": "Cập nhật bệnh án chỉnh nha",
    "admin.orthodontic_plans.approve": "Phê duyệt bệnh án chỉnh nha",
    "admin.orthodontic_plans.unapprove": "Hủy phê duyệt bệnh án chỉnh nha",

    // Khám tổng quát
    "admin.general_exams.create": "Tạo phiếu",
    "admin.general_exams.update": "Cập nhật phiếu",
    "admin.general_exams.approve": "Xác nhận phiếu",
    "admin.general_exams.unapprove": "Hủy xác nhận phiếu",
    'admin.general_exams.remove': 'Xoá',
    'admin.general_exams.detail': 'Xem chi tiết',

    // Khám chỉnh nha
    "admin.orthodontic_exams.create": "Tạo phiếu",
    "admin.orthodontic_exams.remove": "Xóa phiếu",
    "admin.orthodontic_exams.update": "Cập nhật phiếu",
    "admin.orthodontic_exams.approve": "Xác nhận phiếu",
    "admin.orthodontic_exams.unapprove": "Hủy xác nhận phiếu",

    'admin.treatment_sessions.list': 'Xem danh sách',
    'admin.treatment_sessions.create': 'Thêm mới',
    'admin.treatment_sessions.update': 'Cập nhật',
    'admin.treatment_sessions.toggle_orthodontic_status': 'Cập nhật trạng thái chỉnh nha',
    'admin.treatment_sessions.remove': 'Xoá',
    'admin.treatment_sessions.detail': 'Xem chi tiết',
    'admin.treatment_sessions.approve': 'Xác nhận phiếu',
    'admin.treatment_sessions.unapprove': 'Hủy xác nhận phiếu',

    'admin.medical_records.update': 'Cập nhật bệnh án',
    'admin.medical_records.approve': 'Xác nhận bệnh án',
    'admin.medical_records.unapprove': 'Hủy xác nhận bệnh án',

    "admin.telesale_follow_up.list": "Xem danh sách",
    "admin.telesale_follow_up.assign": "Giao khách hàng cho telesale",
    "admin.telesale_follow_up.update": "Cập nhật",
    "admin.telesale_follow_up.update_result": "Trả kết quả telesale",
    "admin.telesale_follow_up.delete": "Xóa",


    "admin.feedback_requests.list": "Xem danh sách",
    "admin.feedback_requests.create": "Tạo mới",
    "admin.feedback_requests.detail": "Xem chi tiết",
    "admin.feedback_requests.update": "Cập nhật",
    "admin.feedback_requests.remove": "Xóa",

    "admin.doctor_customers.list": "Xem danh sách",
    "admin.doctor_appointments.list": "Xem danh sách",

    "admin.monitorings.view": "Xem danh sách",

    // card title
    "admin.permissions": "Phân quyền",
    "admin.user": "Nhân viên",
    "admin.config": "Cài đặt chung",
    "admin.services": "Danh mục dịch vụ",
    "admin.customer_class": "Hạng khách hàng",
    "admin.relationship_types": "Quan hệ gia đình",
    "admin.customer_status": "Trạng thái khách hàng",
    "admin.interaction_statuses": "Trạng thái tương tác",
    "admin.interaction_types": "Loại tương tác",
    "admin.customer": "Khách hàng",
    "admin.page_manager": "Danh sách fanpage",
    "admin.branch": "Cơ sở",
    "admin.role_group": "Nhóm vai trò",
    "admin.roles": "Vai trò",
    "admin.customer_services": "Dịch vụ",
    "admin.customer_source": "Nguồn khách hàng",
    "admin.customer_schedule": "Lịch hẹn",
    "admin.diseases": "Danh sách bệnh",
    "admin.blood_groups": "Nhóm máu",
    "admin.voucher": "Voucher",
    "admin.order": "Đơn hàng",
    "admin.product_group": "Nhóm sản phẩm",
    "admin.product": "Sản phẩm",
    "admin.product_receipt_import": "Phiếu nhập",
    "admin.product_supplier": "Nhà cung cấp",
    "admin.product_warehouse": "Danh sách kho",
    "admin.product_receipt_export": "Phiếu xuất",
    "admin.unit": "Đơn vị tính",
    "admin.product_status": "Tình trạng sản phẩm",
    "admin.guide": "Hướng dẫn sử dụng",
    "admin.work_report": "Báo cáo công việc",
    "admin.telegram": "Cài đặt telegram",
    "admin.lookup_customer": "Tra cứu khách hàng",
    "admin.customer_telesale": "Telesale - cũ",
    "admin.customer_consultant_direct": "Tư vấn trực tiếp",
    "admin.customer_potential": "Khách hàng tiềm năng",
    "admin.cash_receipt": "Phiếu thu",
    "admin.payment_voucher": "Phiếu chi",
    "admin.reward_spin": "Quay thưởng",
    "admin.view_phonenumber": "Lịch sử xem số điện thoại",
    "admin.project": "Dự án",
    "admin.project_based_job": "Công việc",
    "admin.messenger": "Messenger",
    "admin.customer_medical": "Thông tin y tế",
    "admin.cash_book": "Sổ quỹ",
    "admin.customer_doctor_assistant": "Khách hàng",
    "admin.doctor_assistant_status": "Danh sách bác sĩ, phụ tá",
    "admin.card_issued_count": "Số lượng thẻ được phát đi",
    "admin.card_release_tracking": "Theo dõi phát hành thẻ",
    "admin.card_type": "Loại thẻ",
    "admin.card_pending_customers": "Khách hàng chờ làm thẻ",
    "admin.customer_data": "Dữ liệu khách hàng",
    "admin.media_categories": "Danh mục media",
    "admin.media": "Media",
    "admin.document_categories": "Danh mục văn bản",
    "admin.documents": "Văn bản",
    "admin.customer_group": "Nhóm khách hàng",
    "admin.customer_payment": "Hình thức thanh toán",
    "admin.additional_cost": "Chi phí bổ sung",
    "admin.commission": "Hoa hồng",
    "admin.commission_rule": "Cấu hình quy tắc",
    "admin.commission_revenue": "Cấu hình doanh thu",
    "admin.zalo": "Cài đặt Zalo OA",
    "admin.audit_logs": "Audit logs",
    "admin.labos": "Đối tác Labo",
    "admin.labo_cases": "Ca gửi Labo",
    "admin.statistics": "Báo cáo & Thống kê",
    "admin.branch_fund": "Quỹ cơ sở",
    "admin.partner_appointments": "Lịch hẹn",
    "admin.partner_telesales": "Telesales",
    "admin.partner_customers": "Khách hàng",
    "admin.procedures": "Thủ thuật",
    "admin.customer_care_categories": "Danh mục chăm sóc khách hàng",
    "admin.milestones": "Quản lý ca invi",
    "admin.instruction_templates": "Mẫu lời dặn",
    "admin.prescription_templates": "Mẫu đơn thuốc",
    "admin.images": "Ảnh khách hàng",
    "admin.orthodontic_plans": "Bệnh án chỉnh nha",
    "admin.orthodontic_comments": "Bình luận chỉnh nha",
    "admin.treatment_sessions": "Phiếu điều trị",
    "admin.general_exams": "Phiếu khám tổng quát",
    "admin.orthodontic_exams": "Phiếu khám chỉnh nha",
    "admin.medical_records": "Bệnh án tổng quát",
    "admin.customer_care_logs": "Chăm sóc khách hàng",
    "admin.customer_complaints": "Phản ánh của khách hàng",
    "admin.telesale_follow_up": "Theo dõi telesale",
    "admin.feedback_requests": "Yêu cầu chỉnh sửa",
    "admin.doctor_customers": "Danh sách bệnh nhân",
    "admin.doctor_appointments": "Lịch hẹn khám",
    "admin.monitorings": "Giám sát vận hành"
};
